import React from "react";
import "../About/About.css";
import img1 from "../../assets/images/page2_img02.jpg";
import img2 from "../../assets/images/page2_img03.jpg";
import img3 from "../../assets/images/page2_img04.jpg";
import img4 from "../../assets/images/page2_img05.jpg";
import img5 from "../../assets/images/mission.png";
import img6 from "../../assets/images/goal.png";
import img7 from "../../assets/images/process.png";
import img8 from "../../assets/images/Intentionalityicn.png";
import img9 from "../../assets/images/Trust-&-Privacy.png";
import img10 from "../../assets/images/Cultural-Sensitivity.png";
import img11 from "../../assets/images/Connection-Over-Convenience.png";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import imges from "../../assets/images/aboutetextimg.jpg";
import ortmimg1 from "../../assets/images/ortmimg1.jpg";
import ortmimg2 from "../../assets/images/ortmimg2.jpg";
import ortmimg3 from "../../assets/images/ortmimg3.jpg";
import ortmimg4 from "../../assets/images/ortmimg4.jpg";
import ortmimg5 from "../../assets/images/ortmimg5.jpg";
import ortmimg6 from "../../assets/images/ortmimg6.jpg";
import serious from "../../assets/images/serious.jpg";
import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
const missionStatements = [
  {
    id: 1,
    title: "Our Mission",
    img: img5,
    dis: `'To create a trusted global matchmaking platform where serious individuals can find lasting love based on shared values, emotional compatibility, and cultural alignment' To connect people who are ready to love, ready to commit, and ready to build relationships that lasts' `,
  },
  {
    id: 2,
    title: "Our Goal",
    img: img6,
    dis: `Real people. Real intentions. Real love.<br />
          We’re not just building a platform, we’re building a community of trust and purpose. `,
  },
  {
    id: 3,
    title: "Our Process",
    img: img7,
    dis: `Love, Carefully Curated.<br /> At ConnectToVow, we don’t leave your love story to chance.Every step of our process is designed to help you find the right person, with intentionality, safety, and respect.`,
  },
];
const testimonials = [
  {
    id: 1,
    name: "Intentionality",
    img: img8,
    dis: "Here for those who are dating with purpose and looking to walk the journey to Forever.",
  },
  {
    id: 2,
    name: "Trust & Privacy",
    img: img9,
    dis: "Your story is safe with us. We prioritize manual profile verification and admin-controlled match approvals to protect your journey.",
  },
  {
    id: 3,
    name: "Cultural Sensitivity",
    img: img10,
    dis: "We honor your cultural values, personal preferences, and beliefs because love thrives in spaces where you feel seen and respected.",
  },
  {
    id: 4,
    name: "Connection Over Convenience",
    img: img11,
    dis: "Not the quickest but the right connection.",
  },
];

const Aboutold = () => {
  const Navigate = useNavigate();
  const teamMembers = [
    { id: 1, name: "RITA NELSON", img: img1 },
    { id: 2, name: "LAURA STEGNER", img: img2 },
    { id: 3, name: "JOHN NILSON", img: img3 },
    { id: 4, name: "JESSICA PRISTON", img: img4 },
  ];
  return (
    <div className="about-container">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>About Us</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          About Us
        </p>
      </div>
      <div className="about-banner">
        <div className="containerall">
          <div className="firstdiv">
            <div className="about-text">
              <h5>About Us</h5>
              <h2 className="about-title">Who We Are</h2>
              <h4 className="about-subtitle">
                Purposeful Matchmaking. Genuine Connections. Love That Lasts.
              </h4>

              <p className="about-description">
                At ConnectToVow, we believe love is sacred, marriage is
                intentional, and finding the right person shouldn't feel like a
                gamble. We are a compatibility-driven matchmaking platform built
                for people who are serious about love and committed to building
                meaningful, lifelong relationships.
              </p>
              <p className="about-description">
                Modern dating apps, instant matches, superficial talks, and
                constant swiping without any real direction can be frustrating,
                and we get that. We have therefore established a setting that
                values cultural sensitivity, depth, and trust.{" "}
              </p>
              <p className="about-description">
                We don't only use the standard algorithms.
                <br />
                To find matches that genuinely make sense for you, we take into
                account your temperament, key beliefs, life objectives, and
                cultural background.
              </p>
              <p className="about-description">
                Our internal team manually examines and validates every profile
                to ensure authenticity and promote trust. Unlike traditional
                platforms, users are added only when a mutual match has been
                discovered. Profile display is restricted to matched connections
                in order to preserve privacy and concentration.
              </p>
              <button className="main-btn" onClick={() => Navigate("/Login")}>
                Find A Match
              </button>
            </div>

            <div className="about-image">
              <img src={imges} alt="Couple" />
            </div>
          </div>
        </div>
      </div>

      <div
        className="our-membr"
        style={{
          backgroundImage: `url(${serious})`,
        }}
      >
        <div className="about-bg">
          <div className="containerall">
            <div className="fifthDiv">
              {/* <h2 className="testimonial-title">Serious About Love</h2>

              <h4 className="testimonial-title-header">
                We’re here for people who are ready for lasting love, not casual
                connections.
              </h4> */}
              {/* <h5 className="testimonial-title-header">Our Values</h5> */}
              <h2 className="testimonial-title">Our Values</h2>

              <div className="testimonials">
                {testimonials.map((testimonial) => (
                  <div className="testimonial" key={testimonial.id}>
                    <div className="testl-img">
                      <img
                        src={testimonial.img}
                        alt={testimonial.name}
                        className="testimonial-img"
                      />
                    </div>
                    <h3 className="testimonial-name">{testimonial.name}</h3>
                    <p className="testimonial-text">{testimonial.dis}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="our-team">
        <div className="containerall">
          <div className="thirdDiv">
            <h2 className="team-title">Our Team</h2>
            <div className="team-members">
              {teamMembers.map((member) => (
                <div className="team-card" key={member.id}>
                  <img
                    src={member.img}
                    alt={member.name}
                    className="team-img"
                  />
                  <h2 className="team-names">{member.name}</h2>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div> */}
      <div className="our-team">
        <div className="containerall">
          <div className="thirdDiv">
            <h2 className="team-title">Our Team</h2>
            <div className="team-members">
              <div className="team-card">
                <div className="img-box">
                  <img src={ortmimg1} alt="" />
                </div>
                <div className="text-box">
                  <div className="name">Emmanuel Oyedeji</div>
                  <div className="location">Founder, ConnectToVow</div>
                  <div className="underline"></div>
                  <div className="contact-info">
                    <p>
                      Emmanuel Oyedeji is a UK-based entrepreneur, certified
                      project leader, and the visionary behind ConnectToVow, a
                      modern matchmaking platform rooted in compatibility,
                      character, and Christian values.
                    </p>
                  </div>
                </div>
              </div>
              <div className="team-card">
                <div className="img-box">
                  <img src={ortmimg2} alt="" />
                </div>
                <div className="text-box">
                  <div className="name">Kayode Kumapayi</div>
                  <div className="location">Tech Advisor</div>
                  <div className="underline"></div>
                  <div className="contact-info">
                    <p>
                      Kayode Kumapayi is a versatile Digital Solutions and
                      Business Intelligence expert with over 10 years of
                      experience delivering impactful data, fintech, and
                      cloud-based solutions.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="team-card">
                <div className="img-box">
                  <img src={ortmimg3} alt="" />
                </div>
                <div className="text-box">
                  <div className="name">Oreofe Ajetunmobi</div>
                  <div className="location">Legal Advisor</div>
                  <div className="underline"></div>
                  <div className="contact-info">
                    <p>
                      Oreofe is a skilled legal practitioner with a strong focus
                      on estate management, corporate governance ,tech law and
                      commercial legal advisory.{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="team-card">
                <div className="img-box">
                  <img src={ortmimg4} alt="" />
                </div>
                <div className="text-box">
                  <div className="name">Ibukun Olaoye</div>
                  <div className="location">Strategic Partnership Lead</div>
                  <div className="underline"></div>
                  <div className="contact-info">
                    <p>
                      Ibukun Olaoye is a strategic marketing leader with a
                      passion for purpose-driven brands and inclusive growth.
                    </p>
                  </div>
                </div>
              </div>
              <div className="team-card">
                <div className="img-box">
                  <img src={ortmimg5} alt="" />
                </div>
                <div className="text-box">
                  <div className="name">Ben Enahoro</div>
                  <div className="location">Brand Strategy Advisor</div>
                  <div className="underline"></div>
                  <div className="contact-info">
                    <p>
                      Ben Enahoro is a seasoned creative strategist and branding
                      expert with over 15 years of experience in shaping
                      impactful brand identities across Africa.
                    </p>
                  </div>
                </div>
              </div>
              <div className="team-card">
                <div className="img-box">
                  <img src={ortmimg6} alt="" />
                </div>
                <div className="text-box">
                  <div className="name">Tolu Adeniyi</div>
                  <div className="location">Copywriter/UX Writer</div>
                  <div className="underline"></div>
                  <div className="contact-info">
                    <p>
                      A dynamic content/copywriter who prides herself as a
                      channel of African Storytelling. At the heart of Tolu’s
                      role is crafting clear, emotionally intelligent messaging
                      that bridges technology and human connection.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="our-sttmnt">
        <div className="containerall">
          <div className="forthDiv">
            <h2 className="mission-title">Mission Statement</h2>
            <div className="mission-cards">
              {missionStatements.map((mission) => (
                <div className="mission-card" key={mission.id}>
                  <div className="mission-top">
                    <div className="mission-img">
                      <img
                        src={mission.img}
                        alt={mission.title}
                        className="mission-imggg"
                      />
                    </div>
                  </div>
                  <div className="mission-content">
                    <h3 className="mission-heading">{mission.title}</h3>
                    <p
                      className="mission-text"
                      dangerouslySetInnerHTML={{ __html: mission.dis }}
                    ></p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutold;
